import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../theme/cards/BaseCard"
import { tokens } from "../../../../theme";
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import { t } from "i18next";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import { GridCheckIcon } from "@mui/x-data-grid";
import { ClearIcon } from "@mui/x-date-pickers";

const WhiteListCard = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    // const solved = props.skeleton ? false : props.row.solved ?? false;
    // const solvedText = solved ? "Solved" : "Not solved";
    // const solvedColor = solved ? "green" : "red";

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box>
                    <Box display={"flex"} width={props.skeleton ? "50%" : null} flexDirection={"column"}>
                        {props.skeleton ?
                            <ShDoubleTextSkeleton/>
                            :
                            <>
                                <Text bold>{props.description}</Text>
                                <Text>{props.ipAddress}</Text>
                            </>
                        }
                    </Box>

                    <Box
                        sx={{
                            mt:2,
                            display:"flex",
                            gap:3,
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                flexDirection:'column'
                            }}
                        >
                            <Text light>{t("global_login")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/>
                            :
                                <>
                                    {props.globalLogin ? (
                                        <GridCheckIcon sx={{ color: colors.green[400] }} />
                                    ) : (
                                        <ClearIcon sx={{ color: colors.red[400] }} />
                                    )}
                                </>
                            }
                        </Box>
                        <Box
                            sx={{
                                display:"flex",
                                flexDirection:'column'
                            }}
                        >
                            <Text light>{t("tag_login")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/>
                            :
                                <>
                                    {props.tagLogin ? (
                                        <GridCheckIcon sx={{ color: colors.green[400] }} />
                                    ) : (
                                        <ClearIcon sx={{ color: colors.red[400] }} />
                                    )}
                                </>
                            }
                        </Box>

                    </Box>

                </Box>
            </Box>
        </BaseCard>
    )
}

export default WhiteListCard;